<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" lg="4">
        <v-card class="elevation-12" min-width="500" v-if="requestStage != 'ended'">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Восстановление пароля</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
              <div v-if="requestStage == 'init'">
                <v-radio-group v-model="recoveryMode" row mandatory>
                  <v-radio label="По имени пользователя" value="uname"></v-radio>
                  <v-radio label="По электронной почте" value="email"></v-radio>
                </v-radio-group>
              </div>
              <div class="black--text" v-else>
                Для указанного имени пользователя найден адрес электронной почты - <b>{{ requestResult }}</b>.<br>
                В текстовом поле ниже, введите этот адрес <b>полностью</b><br> <br>
              </div>
              <v-text-field
                v-model="requestData"
                :label="getTFLabel()"
                type="text"
                required
                @keyup.enter="doRequest"
                v-if="requestStage !== 'ended'"
              ></v-text-field>
          </v-card-text>
          <v-card-actions>
              <v-btn outlined rounded color="primary" @click="cancelRestore()" min-width="200">Отмена</v-btn>
              <v-spacer></v-spacer>
              <v-btn  rounded color="#005578" class="white--text" @click.native="doRequest(this)" min-width="200" :disabled="!canRequest">Запрос</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="elevation-12" v-if="requestStage == 'ended'">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Запрос принят к обработке</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <p class="display-1 text--primary">
              Запрос на восстановление доступа принят к обработке.
            </p>
            <div class="text--primary">
              Ваша заявка зарегистрирована в системе.<br>
              Атрибуты доступа будут отправлены Вам на указанную электронную почту <b>{{ requestData }}</b><br><br>
              <b>Благодарим за использование нашего сервиса!</b>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined rounded color="primary" @click="cancelRestore()" min-width="200">ОК</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AUTH_PR_REQUEST } from '@/store/actions/auth'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'sysPasswordReminder',
  data () {
    return {
      requestData: '',
      requestData2: '',
      recoveryMode: null,
      requestStage: 'init',
      requestResult: ''
    }
  },
  computed: {
    canRequest: {
      get: function () {
        var fp = Boolean(this.requestData)
        return fp && !this.progress
      }
    }
  },
  methods: {
    getTFLabel () {
      if (this.requestStage === 'init') {
        if (this.recoveryMode === 'email') {
          return 'Введите email, указанный при регистрации'
        }
        if (this.recoveryMode === 'uname') {
          return 'Введите имя пользователя'
        }
      }
      if (this.requestStage === 'inited') {
        return 'Введите email, ПОЛНОСТЬЮ'
      }
    },
    cancelRestore () {
      this.$router.push('/login')
    },
    doRequest: function (e) {
      console.log('sending request')
      if (e) { e.preventDefault() }
      const { requestData, recoveryMode, requestStage, requestData2 } = this
      this.progress = true
      this.$store.dispatch(AUTH_PR_REQUEST, { requestData, recoveryMode, requestStage, requestData2 })
        .then((data) => {
          if (data.error === 'ok') {
            this.requestResult = data.data
            if (this.requestStage === 'inited') {
              console.log('Middle phase completed: ', this.requestStage)
              this.requestStage = 'ended'
            }
            if (this.requestStage === 'init') {
              if (this.recoveryMode === 'uname') {
                this.requestStage = 'inited'
                this.requestData2 = this.requestData
                this.requestData = ''
                console.log('Init phase completed: ', this.requestStage)
              } else {
                this.requestStage = 'ended'
              }
            }
          }
        })
        .catch((err) => {
          console.log('Auth rejected')
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
        .finally(() => {
          this.progress = false
        })
    }
  }
}
</script>
